<template>
  <div class="w-full">
    <cardTitle title="参建人员总数统计" cardType='shimen'/>
    <div class="participate_item_cont flex">
      <div
        class="item_r_cont"
        v-for="(it, index) in unitList"
        :key="index"
        @click="clickPersonItem(it)"
      >
        <div class="flex justify-between text-white">
          <div class="flex">
            <div
              class="text-[12px] title_bg"
              :style="{
                backgroundImage: `url(${require('../../assets/image/bg_sortcjdw.png')})`,
              }"
            >
              {{ index + 1 }}
            </div>
            <div class="text-14px w-280px truncate">{{ it.name }}</div>
          </div>
          <div>
            <span class="text-16px">{{ it.num }}&nbsp;</span>
            <span class="text-16px total_num">/</span>
            <span class="text-12px total_num">{{ participateUnitPersonTotal }}</span>
          </div>
        </div>
        <div class="progress_cont flex">
          <div
            :style="{
              width: `${(it.num / participateUnitPersonTotal) * 100}%`,
              background: `#528dff`,
              transition: 'all .5s',
            }"
          ></div>
        </div>
      </div>
    </div>
     <PersonDialog
      v-if="personDialogVisible"
      :deptName="deptName"
      :dialogType="dialogType"
      :visible="personDialogVisible"
      @close="closePersonDialog"
      class="personDialog"
    ></PersonDialog>
  </div>
</template>

<script>
import CardTitle from '@/components/cockpit/CardTitle'
import PersonDialog from '../PersonDialog.vue'

import CockpitService from '../../service/index'

export default {
  name: '',
  props: [],
  components: { CardTitle, PersonDialog },

  data() {
    return {
      initInterval: null,
      unitList: [],
      participateUnitPersonTotal: 0,
      deptName: '',
      dialogType: '',
      personDialogVisible: false,
    }
  },
  methods: {
    // 获取参建人员统计数据
    async getUnitPersonData() {
      const [err, res] = await CockpitService.getUnitPersonData()
      if (res && res.data && res.code === 0) {
        this.participateUnitPersonTotal = res.data.allCount
        this.unitList = res.data.list.map((it) => {
          return {
            name: it.workPermissionName,
            num: it.count,
            Id: it.workPermissionId,
          }
        })
      }
    },
    closePersonDialog() {
      this.personDialogVisible = false
    },
    clickPersonItem(data) {
      this.dialogType = 'person'
      this.deptName = data.Id
      this.personDialogVisible = true
    },
  },
  beforeDestroy() {
    clearInterval(this.initInterval)
  },
  mounted() {
    this.getUnitPersonData()
    this.initInterval = setInterval(() => {
      this.getUnitPersonData()
    }, 5000)
  },
}
</script>

<style lang="scss" scoped>
.participate_item_cont::-webkit-scrollbar {
  display: none;
}
.participate_item_cont {
  height: calc(100% - 52px);
  flex-direction: column;
  overflow: auto;
  .item_r_cont {
    height: 42px;
    margin-top: 10px;
    cursor: pointer;
  }
  .title_bg {
    width: 22px;
    height: 22px;
    text-align: center;
    line-height: 22px;
    margin-right: 10px;
    // background-image: url('../assets/personImg/bg_sortcjdw.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center 0;
  }
  .total_num {
    color: #ffffff99;
  }
  .progress_cont {
    height: 10px;
    border: 1px solid #edefff19;
    margin: 5px 0 0 32px;
  }
}
</style>
